import {createContext, useReducer} from 'react'

import PropTypes from 'prop-types'

import {ACTION} from './actions.js'
import {FIELDS, initialState, reducer} from './reducer.js'
const NO_OP = () => {}

export const FormContactSellerContext = createContext()

const FormContactSellerProvider = props => {
  const {
    children,
    ad,
    adId,
    buttonCallSeller,
    // abtest4_web_lead_experience_whatsapp_button
    buttonWhatsapp,
    contractId,
    dealer,
    handleOnFieldChange = NO_OP,
    handleScrollToB2cFinancingPanel,
    handleScrollToFinancingTerms,
    initialMessage,
    isModal = false,
    textareaSize,
    isSellerBlocked,
    isSubscriptionLead,
    isZipCodeEnabled,
    leadData,
    onContact,
    offerTypeId,
    pageName,
    price,
    province,
    redirectTo,
    search,
    showLabels = true,
    showReservationMainCTA,
    showSearchSave,
    showSellerCallLinkButton = true,
    showTargetBuyerOptions,
    targetBuyer,
    userData,
    vehicle,
    onCreateAlert,
    enableAlertCreation = false,
    enableLeadEnrichment = false,
    initialLeadEnrichmentValue,
    sellerId,
    hideButtonsSeparator = false,
    enableAuthBeforeLead = false,
    subscriptionPriceOptionSelected,
    authenticationHitInformation2
  } = props

  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...(initialMessage && {
      [FIELDS.MESSAGE.NAME]: {
        ...initialState[FIELDS.MESSAGE.NAME],
        value: initialMessage || initialState[FIELDS.NAME.NAME].value
      }
    }),
    ...(Boolean(userData) && {
      isLogged: true,
      [FIELDS.NAME.NAME]: {
        ...initialState[FIELDS.NAME.NAME],
        hasError: Boolean(userData.name),
        isDisabled: Boolean(userData.name),
        value: userData.name || initialState[FIELDS.NAME.NAME].value
      },
      [FIELDS.EMAIL.NAME]: {
        ...initialState[FIELDS.EMAIL.NAME],
        hasError: Boolean(userData.email),
        isDisabled: Boolean(userData.email),
        value: userData.email || initialState[FIELDS.EMAIL.NAME].value
      },
      [FIELDS.ZIPCODE.NAME]: {
        ...initialState[FIELDS.ZIPCODE.NAME],
        value: userData.zipCode || initialState[FIELDS.ZIPCODE.NAME].value
      },
      [FIELDS.PHONE.NAME]: {
        ...initialState[FIELDS.PHONE.NAME],
        isDisabled: Boolean(userData.phone),
        value: userData.phone || initialState[FIELDS.PHONE.NAME].value
      },
      [FIELDS.TARGET_BUYER.NAME]: {
        ...initialState[FIELDS.TARGET_BUYER.NAME],
        value: targetBuyer || initialState[FIELDS.TARGET_BUYER.NAME].value
      },
      [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
        ...initialState[FIELDS.TERMS_AND_CONDITIONS.NAME],
        isShown: false,
        value: true
      },
      [FIELDS.ENABLE_ALERTS.NAME]: {
        ...initialState[FIELDS.ENABLE_ALERTS.NAME]
      }
    }),
    isSellerBlocked
  })

  const setCurrentUser = currentUser => {
    return dispatch({
      type: ACTION.SET_FIELDS_WITH_USER_LOGGED_DATA,
      payload: currentUser
    })
  }

  const setFieldsLastContact = lastContactDetails => {
    return dispatch({
      type: ACTION.SET_FIELDS_WITH_LAST_CONTACT_DETAILS,
      payload: lastContactDetails
    })
  }

  const setFormWithCaptcha = () =>
    dispatch({
      type: ACTION.FORM_HAS_CAPTCHA
    })

  const updateField = (field, value) => {
    handleOnFieldChange(field, value)
    dispatch({
      type: ACTION.UPDATE_FIELD_VALUE,
      payload: {
        field,
        value
      }
    })
  }
  const updateErrorsFields = errorsObj =>
    dispatch({
      type: ACTION.UPDATE_FORM_ERRORS,
      payload: errorsObj
    })

  const hasSuccesfulCaptcha = token =>
    dispatch({
      type: ACTION.USER_HAS_SUCCESSFUL_CAPTCHA,
      payload: {captchaToken: token}
    })

  const setUserSubmitted = () => dispatch({type: ACTION.USER_HAS_SUBMITTED})
  const setUserContact = payload => dispatch({type: ACTION.USER_HAS_CONTACTED, payload})
  const setFormContactErrors = () => dispatch({type: ACTION.FORM_HAS_CONTACT_ERROR})

  const setIsFormSubmitted = isFormSubmitted =>
    dispatch({type: ACTION.SET_IS_FORM_SUBMITTED, payload: {isFormSubmitted}})
  const setIsSellerBlocked = isSellerBlocked =>
    dispatch({type: ACTION.SET_IS_SELLER_BLOCKED, payload: {isSellerBlocked}})

  const setAuthBeforeLeadResult = ({userHasBeenRegistered, autoGeneratedPassword}) =>
    dispatch({type: ACTION.SET_AUTH_BEFORE_LEAD_RESULT, payload: {userHasBeenRegistered, autoGeneratedPassword}})

  const value = {
    state,
    currentProps: {
      ad,
      adId,
      buttonCallSeller,
      // abtest4_web_lead_experience_whatsapp_button
      buttonWhatsapp,
      children,
      contractId,
      dealer,
      handleScrollToB2cFinancingPanel,
      handleScrollToFinancingTerms,
      initialMessage,
      isModal,
      textareaSize,
      isSellerBlocked,
      isSubscriptionLead,
      isZipCodeEnabled,
      leadData,
      offerTypeId,
      onContact,
      pageName,
      price,
      province,
      redirectTo,
      search,
      showLabels,
      showReservationMainCTA,
      showSearchSave,
      showSellerCallLinkButton,
      showTargetBuyerOptions,
      targetBuyer,
      userData,
      vehicle,
      onCreateAlert,
      enableAlertCreation,
      enableLeadEnrichment,
      initialLeadEnrichmentValue,
      sellerId,
      hideButtonsSeparator,
      enableAuthBeforeLead,
      subscriptionPriceOptionSelected,
      authenticationHitInformation2
    },
    actions: {
      setCurrentUser,
      setFieldsLastContact,
      setFormWithCaptcha,
      updateField,
      updateErrorsFields,
      hasSuccesfulCaptcha,
      setUserSubmitted,
      setUserContact,
      setFormContactErrors,
      setIsFormSubmitted,
      setIsSellerBlocked,
      setAuthBeforeLeadResult
    }
  }

  return <FormContactSellerContext.Provider value={value}>{children}</FormContactSellerContext.Provider>
}

FormContactSellerProvider.displayName = 'FormVehicleProvider'
FormContactSellerProvider.propTypes = {
  ad: PropTypes.object,
  children: PropTypes.node.isRequired,
  adId: PropTypes.number,
  buttonCallSeller: PropTypes.node,
  // abtest4_web_lead_experience_whatsapp_button
  buttonWhatsapp: PropTypes.node,
  contractId: PropTypes.number,
  dealer: PropTypes.object,
  handleOnFieldChange: PropTypes.func,
  handleScrollToB2cFinancingPanel: PropTypes.func,
  handleScrollToFinancingTerms: PropTypes.func,
  initialMessage: PropTypes.string,
  isModal: PropTypes.bool,
  textareaSize: PropTypes.string,
  isSellerBlocked: PropTypes.bool,
  isSubscriptionLead: PropTypes.bool,
  isZipCodeEnabled: PropTypes.bool,
  leadData: PropTypes.object,
  onContact: PropTypes.func,
  offerTypeId: PropTypes.number,
  pageName: PropTypes.string,
  price: PropTypes.shape({
    financedPrice: PropTypes.number,
    price: PropTypes.number
  }),
  province: PropTypes.string,
  redirectTo: PropTypes.func,
  search: PropTypes.object,
  showLabels: PropTypes.bool,
  showReservationMainCTA: PropTypes.bool,
  showSearchSave: PropTypes.bool,
  showSellerCallLinkButton: PropTypes.bool,
  showTargetBuyerOptions: PropTypes.bool,
  targetBuyer: PropTypes.string,
  userData: PropTypes.object,
  vehicle: PropTypes.string,
  onCreateAlert: PropTypes.func,
  enableAlertCreation: PropTypes.bool,
  enableLeadEnrichment: PropTypes.bool,
  initialLeadEnrichmentValue: PropTypes.arrayOf(PropTypes.string),
  sellerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hideButtonsSeparator: PropTypes.bool,
  enableAuthBeforeLead: PropTypes.bool,
  subscriptionPriceOptionSelected: PropTypes.shape({
    totalMonths: PropTypes.number,
    monthlyPrice: PropTypes.number,
    kmIncluded: PropTypes.number,
    kmIncludedPeriod: PropTypes.string,
    targetBuyer: PropTypes.string
  }),
  authenticationHitInformation2: PropTypes.string
}

export {FormContactSellerProvider, FIELDS}
